import Button from '~/shared/components/ButtonsV2';
import Typography from '~/shared/components/Typography';
import DeleteIcon from '~/shared/assets/icons/delete.svg';

export default function SidepanelFooter({
  onResetFilters,
  onApplyFilters,
  handleClose,
  canReset,
}: {
  onResetFilters: () => void;
  onApplyFilters: () => void;
  handleClose: () => void;
  canReset: boolean;
}) {
  return (
    <div className="flex justify-between items-center w-full ">
      <Button size="sm" variant="third" className="px-4" onClick={handleClose}>
        <Typography variant="buttons-m" fontWeight={600} color="font-family-inter ">
          Cancel
        </Typography>
      </Button>

      <div className="flex gap-2">
        <Button
          size="sm"
          variant="third"
          className="px-4 group disabled:opacity-40 disabled:cursor-not-allowed"
          onClick={onResetFilters}
          leftIcon={
            <DeleteIcon className="size-[18px] aspect-square fill-primary-900 group-hover:stroke-primary-500 group-active:stroke-primary-300 stroke-1" />
          }
          disabled={!canReset}
          title={canReset ? 'Clear all selected filters' : 'No filters to clear'}
        >
          <Typography variant="buttons-m" fontWeight={600} color="font-family-inter ">
            Clear Selection
          </Typography>
        </Button>

        <Button size="sm" className="px-4" onClick={onApplyFilters}>
          <Typography variant="p3" color="">
            Apply
          </Typography>
        </Button>
      </div>
    </div>
  );
}
